var $1057e6307507310d$exports = {};
$1057e6307507310d$exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "placeholder": `\u{9009}\u{62E9}...`
};


export {$1057e6307507310d$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
